// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2JBdJ","title":"Images90_title__3MXQC","images":"Images90_images__2zIu_"};